export default function InfoCard({ card }) {
  return (
    <div className="bg-gray-800/50 p-4 rounded-lg border border-emerald-400/20">
      <h3 className="text-emerald-200 font-semibold mb-2">{card.title}</h3>
      <p className="text-gray-300 text-sm">{card.content}</p>
    </div>
  );
}